module.exports = __webpack_public_path__ + "img/r7.abac1357.jpg";